import axios from 'axios';

const API_URL = process.env.VUE_APP_HOST + '/api/user';

let access_token = "";

let auth = localStorage.getItem('session-authorization');

if (!auth) {
    access_token = process.env.VUE_APP_TOKEN;
    if (!access_token) {
        console.log(window.location.hash)
        var queries = window.location.hash.split("access_token=")
        if (queries.length > 1) {
            access_token = queries[1].split("&")[0]
            if (access_token) {
                let auth = "{\"access_token\":\"" + access_token + "\",\"token_type\":\"\Bearer\",\"expires_in\":\"3600\"}";
                localStorage.setItem('session-authorization', auth);
            }
        }
    }
}
else {
    access_token = JSON.parse(auth).access_token;
}

let headers = {
    headers: {
        'Authorization': `Bearer ${access_token}`,
        'Content-Type': 'application/json'
    }
};

export const userApi = {
    getAllUsers: async () => {
        const response = await axios.get(API_URL, headers);
        return response.data;
    },

    getProfile: async () => {
        try {
            const response = await axios.get(API_URL + '/profile', headers);
            return response.data;
        } catch (error) {
            if (error.response && error.response.status === 404) {
            return null;
            }
            throw error;
        }
    },

    createUser: async (user) => {
        // Ensure the user object has an Id field as an empty string if it's not provided
        const userWithId = { ...user, id: user.id || '' };
        const response = await axios.post(API_URL, userWithId, headers);
        return response.data;
    },

    updateUser: async (id, user) => {
        // Ensure the id is included in the user object
        const userWithId = { ...user, id };
        const response = await axios.put(`${API_URL}/${id}`, userWithId, headers);
        return response.data;
    },

    deleteUser: async (id) => {
        const response = await axios.delete(`${API_URL}/${id}`, headers);
        return response.data;
    },

    getToken: async (email) => {
        const response = await axios.get(API_URL + '/Token/' + email)
        return response.data;
    }
};

